import React from 'react'
import styled, { css } from 'styled-components'

import { CONTAINER_WIDTH } from '../theme'
import Page from './Page'

const Content = styled.div`
  margin: 0 auto;

  ${props => {
    if (props.$isNarrow) {
      return css`
        max-width: 740px;
      `
    }

    return css`
      max-width: ${CONTAINER_WIDTH}px;
    `
  }}
`

const PageInfo = ({ title, children, isNarrow = true }) => {
  return (
    <Page title={title}>
      <Content $isNarrow={isNarrow}>
        {children}
      </Content>
    </Page>
  )
}

export default PageInfo
